module.exports = __webpack_public_path__ + "img/bullet-primary.1fd4746d.svg";